module.exports = __webpack_public_path__ + "static/media/mirabeau.16344f60.svg";